import { CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { StudentCabinetNavigationService } from '../../service/student-cabinet-navigation';
import { StudentCabinetService } from '../../../../student-cabinet/shared/service/student-cabinet-service';
import { NavigationService } from '../../service/navigation-service';

@Injectable({ providedIn: 'root' })
export class OnboardingGuard implements CanActivate {
  private studentCabinetNavigationService = inject(StudentCabinetNavigationService);
  private studentCabinetService = inject(StudentCabinetService);
  private navigationService = inject(NavigationService);

  canActivate(): Observable<boolean> {
    return this.studentCabinetService.needShowOnboarding$.pipe(
      map(needShowOnboarding => {
        if (!needShowOnboarding) {
          return true;
        }

        this.studentCabinetNavigationService.navigateToOnboarding();
        return false;
      }),
      catchError(() => {
        this.navigationService.navigateToServiceUnavailable({ skipLocationChange: true });
        return of(false);
      }),
    );
  }
}
